import { render, staticRenderFns } from "./contentDetailCardChildSlider.vue?vue&type=template&id=2b499ede&scoped=true"
import script from "./contentDetailCardChildSlider.vue?vue&type=script&lang=js"
export * from "./contentDetailCardChildSlider.vue?vue&type=script&lang=js"
import style0 from "./contentDetailCardChildSlider.vue?vue&type=style&index=0&id=2b499ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b499ede",
  null
  
)

export default component.exports